export const TENANT_CONFIG_EXPIRY_DAYS = 7;

export const TENANT_DOMAIN_TYPE_SLUGS = {
  BOTH: 'both',
  PATIENT: 'patient',
  ADMIN: 'admin',
};

export const TENANTS_SLUGS = {
  ELEVATE: 'elevate-health',
  ORALONLY: 'oral-only',
};
